// Author Lin
// Date 2021-10-13 15:43:10

import * as model from "@/model/mintalMes/prd/MintalMesPrdSmeltingPreheatingKilnStopModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdSmeltingPreheatingKilnStop(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
